// extracted by mini-css-extract-plugin
module.exports = {"root":"HomeSlider_root__JNAmv","pic":"HomeSlider_pic__2L4pM"};